import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  width: 100%;
`;

export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  width: 100%;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
`;

